import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AssetKeys } from '../../assets/asset-keys';
import { resolveAsset } from '../../assets/resolve-asset';
import { useThemeAssets } from '../../hooks/use-theme-assets';
import './style.styl';

const PREFIX_CLASS = 'client-layout1';
const propTypes = {
	assets: PropTypes.object,
	backgroundKey: PropTypes.string,
	backgroundKeyMobile: PropTypes.string,
	main: PropTypes.node,
	className: PropTypes.string,
};
const defaultProps = {
	assets: null,
	backgroundKey: AssetKeys.BG_MAIN,
	backgroundKeyMobile: '',
	className: '',
};

function Layout1({
	assets: assetsProp,
	backgroundKey,
	backgroundKeyMobile,
	main,
	className,
}) {
	const assets = assetsProp || useThemeAssets();
	const bgDesktop = resolveAsset(assets, backgroundKey, null);
	const bgMobile = resolveAsset(assets, backgroundKeyMobile || backgroundKey, null);

	useEffect(() => {
		const el = document.getElementById('client-bg-layer') || document.documentElement;

		if (!el) {
			return;
		}

		el.style.setProperty('--client-layout1-bg-desktop', bgDesktop ? `url(${bgDesktop})` : 'none');
		el.style.setProperty('--client-layout1-bg-mobile', bgMobile ? `url(${bgMobile})` : 'none');
	}, [bgDesktop, bgMobile]);

	return (
		<div className={`${PREFIX_CLASS} ${className}`.trim()}>
			<main className={`${PREFIX_CLASS}__main`}>
				{main}
			</main>
		</div>
	);
}

Layout1.propTypes = propTypes;
Layout1.defaultProps = defaultProps;

export default Layout1;
